export const footer = {
  widgets: [
    {
      id: 1,
      widgetTitle: 'widget-title-about',
      lists: [
        {
          id: 1,
          title: 'link-about-us',
          path: '/about-us',
        },
        {
          id: 2,
          title: 'link-contact-us',
          path: 'https://support.foodservicedirect.com/hc/en-us/requests/new',
        },
      ],
    },
    {
      id: 2,
      widgetTitle: 'widget-title-our-information',
      lists: [
        {
          id: 1,
          title: 'link-privacy',
          path: '/privacy',
        },
        {
          id: 2,
          title: 'link-terms',
          path: '/terms',
        },
        {
          id: 3,
          title: 'link-return-policy',
          path: '/return',
        },
      ],
    },
  ],
  payment: [
    {
      id: 1,
      path: '/',
      image: '/assets/images/payment/mastercard.svg',
      name: 'payment-master-card',
      width: 34,
      height: 20,
    },
    {
      id: 2,
      path: '/',
      image: '/assets/images/payment/visa.svg',
      name: 'payment-visa',
      width: 50,
      height: 20,
    },
    {
      id: 3,
      path: '/',
      image: '/assets/images/payment/paypal.svg',
      name: 'payment-paypal',
      width: 76,
      height: 20,
    },
    {
      id: 4,
      path: '/',
      image: '/assets/images/payment/applepay.png',
      name: 'payment-applepay',
      width: 56,
      height: 20,
    },
    {
      id: 5,
      path: '/',
      image: '/assets/images/payment/afterpay.png',
      name: 'payment-afterpay',
      width: 56,
      height: 30,
    },
  ],
  social: [
    {
      id: 1,
      path: 'https://www.facebook.com/people/Food-Service-Direct-Canada/61550110816189/',
      image: '/assets/images/social/facebook.svg',
      name: 'facebook',
      width: 20,
      height: 20,
    },
    {
      id: 2,
      path: 'https://twitter.com/foodsrvcdirect',
      image: '/assets/images/social/twitter.svg',
      name: 'twitter',
      width: 20,
      height: 20,
    },
    {
      id: 3,
      path: 'https://www.instagram.com/foodservicedirectcanada/',
      image: '/assets/images/social/instagram.svg',
      name: 'instagram',
      width: 20,
      height: 20,
    },
    {
      id: 4,
      path: 'https://www.youtube.com/channel/UC61Ow7SDQ1PIBRalrbNl4EA',
      image: '/assets/images/social/youtube.svg',
      name: 'youtube',
      width: 20,
      height: 20,
    },
  ],
}
